module.exports = __webpack_public_path__ + "img/comments-sharp-light.3cb8aeb2.svg";